import loadGTMScript from 'utils/loadGTMScript';

const pushDataLayerEvent = (dataLayerEvent) => {
  if (!dataLayerEvent) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(
    typeof dataLayerEvent === 'string'
      ? { event: dataLayerEvent }
      : dataLayerEvent,
  );
};

const pushMouseflowTag = (mouseflowTag) => {
  if (!mouseflowTag) return;

  const tags = Array.isArray(mouseflowTag) ? mouseflowTag : [mouseflowTag];
  window._mfq = window._mfq || [];
  tags.filter(Boolean).forEach((tag) => {
    window._mfq.push(['tag', tag]);
  });
};

const triggerGtagEvent = (gtagEvent, gtmCode) => {
  if (!gtagEvent) return;

  if (typeof window.gtag === 'function') {
    window.gtag('event', gtagEvent);
    return;
  }

  if (gtmCode) {
    loadGTMScript(gtmCode, gtagEvent);
  }
};

const trackAnalyticsEvent = ({
  dataLayerEvent,
  gtagEvent,
  mouseflowTag,
  gtmCode,
} = {}) => {
  if (typeof window === 'undefined') return;

  pushDataLayerEvent(dataLayerEvent);
  triggerGtagEvent(gtagEvent, gtmCode);
  pushMouseflowTag(mouseflowTag);
};

export default trackAnalyticsEvent;
